module.exports = __webpack_public_path__ + "static/media/search2.59f3a267.png";